import { NgModule , CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { EventsComponent } from './pages/events/events.component';
import { HomeComponent } from './pages/home/home.component';
import {
  AuthGuardService as AuthGuard
} from './_services/auth/auth-guard.service';
import { AddStageComponent } from './pages/stage/add-stage/add-stage.component';
import { AcceuilComponent } from './pages/acceuil/acceuil.component';
import { ContactComponent } from './pages/contact/contact.component';
import { MusicComponent } from './pages/music/music.component';
import { EventsFrontComponent } from './pages/events-front/events-front.component';
import {ProjetsComponent} from './pages/projets/projets.component';
import { PdfFileComponent } from './pages/pdf-file/pdf-file.component';
import {DocumentsComponent} from './pages/documents/documents.component';
import {ComplexeComponent} from './pages/complexe/complexe.component';
import {SponsorsComponent} from './pages/sponsors/sponsors.component';
import {BureauComponent} from './pages/bureau/bureau.component';
import {HistoriqueComponent} from './pages/historique/historique.component';
import {PostsComponent} from './pages/posts/posts.component';
import { GetPostByIdComponent } from './pages/get-post-by-id/get-post-by-id.component';
import { GetEventIdComponent } from './pages/get-event-id/get-event-id.component';
import { RapportFrontComponent } from './pages/rapport-front/rapport-front.component';
const routes: Routes =[
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {path:'music' , component : MusicComponent },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
      }
    ]
  }, {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './layouts/auth-layout/auth-layout.module#AuthLayoutModule'
      }
    ]
  },
 
  { path: 'home', component: HomeComponent,
  children:[
    { path: '', component: AcceuilComponent },
    { path: 'addStage', component: AddStageComponent },
    {path:'contact' , component : ContactComponent },
    {path:'events' , component : EventsFrontComponent },
    {path:'services/projets' , component :ProjetsComponent},
    {path:'services/documents' , component :DocumentsComponent},
    {path:'complexe' , component :ComplexeComponent},
    {path:'bureau' , component :BureauComponent},
    {path:'sponsors' , component :SponsorsComponent},
    {path:'historique' , component :HistoriqueComponent},
    {path:'posts' , component :PostsComponent},
    {path:'rapport' , component :RapportFrontComponent},
   
  ]

},
{
  path:'getPostById' , 
  component :GetPostByIdComponent
},{
  path:'getEventById' , 
  component :GetEventIdComponent
},
  {
    path: '**',
    redirectTo: 'home'
  }
];
@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: true
    })
  ], schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  exports: [
  ],
})
export class AppRoutingModule { }
